// src/composables/useWhatsappSupport.js

// Como usar:
// import { useWhatsappSupport } from '@/composables/useWhatsappSupport';
// // const { whatsappSupportLink } = useWhatsappSupport();

{/* <a
  :href="whatsappSupportLink('Olá! Gostaria de saber mais sobre o upgrade do plano no Avalioo.')"
  target="_blank"
  rel="noopener noreferrer"
  class="ml-2 py-0.5 px-2 bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-300 text-xs font-medium rounded shadow-sm border border-red-300 dark:border-red-700 hover:bg-red-200 dark:hover:bg-red-700 active:translate-y-0.5 active:shadow-none transition-all flex items-center"
> */}


export function useWhatsappSupport() {
    const supportNumber = '559831960908'; // Seu número de suporte com DDI/DDD
  
    const whatsappSupportLink = (message = 'Olá! Preciso de ajuda com o Avalioo.') => {
      const encodedMessage = encodeURIComponent(message);
      return `https://wa.me/${supportNumber}?text=${encodedMessage}`;
    };
  
    return { whatsappSupportLink };
  }


// 